<template>
    <div class="analyst-quote">
        <!-- 左侧：头像 + 名称 + 公司 -->
        <div class="analyst-quote__left">
            <div class="analyst-quote__avatar">
                <img v-if="avatar" :src="avatar" :alt="name" />
                <span v-else class="analyst-quote__avatar-placeholder">{{ name ? name.charAt(0) : 'A' }}</span>
            </div>
            <div class="analyst-quote__info">
                <div class="analyst-quote__name-row">
                    <span class="analyst-quote__name">{{ name }}</span>
                    <!-- <TopRankBadge v-if="rank" :text="`TOP${rank}`" /> -->
                </div>
                <span class="analyst-quote__company">{{ company }}</span>
            </div>
        </div>

        <!-- 右侧：箭头 -->
        <div class="analyst-quote__right">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 4L10 8L6 12"
                    stroke="#000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
    </div>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  avatar: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  company: {
    type: String,
    default: ''
  },
  rank: {
    type: Number,
    default: 0
  }
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.analyst-quote {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.21rem;

    &__left {
        display: flex;
        align-items: center;
        gap: 0.24rem;
    }

    &__avatar {
        width: 0.65rem;
        height: 0.65rem;
        border-radius: 0.325rem;
        overflow: hidden;
        background: #333;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__avatar-placeholder {
        font-size: 0.36rem;
        font-weight: 600;
        color: #fff;
    }

    &__info {
        display: flex;
        flex-direction: column;
    }

    &__name-row {
        display: flex;
        align-items: center;
        gap: 0.1rem;
    }

    &__name {
        font-size: 0.3rem;
        font-weight: 600;
        color: #000000;
    }

    &__company {
        font-size: 0.22rem;
        font-weight: 400;
        color: #626262;
    }

    &__right {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0.32rem;
        height: 0.32rem;

        svg {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
